import {
    changeNumberOfCopiesForSelectedRowForPriceTable,
    changeSelectedIds,
    getDataForDownloadRegItems,
    getStateForTable,
    setDataPrintStatus,
    setSelectedRowForPricesTable
} from "../../../../../Redux/content-reducer";
import {connect} from "react-redux";
import {getFormat} from "../../../../../Redux/format-reducer";
import {TableContentRow} from "./TableContentRow";


let mapStateToProps = (state) => {
    return {
        data: state
    }
};

const mapDispatchToProps = {
    setDataPrintStatus,
    getStateForTable,
    setSelectedRowForPricesTable,
    getDataForDownloadRegItems,
    getFormat,
    changeSelectedIds,
    changeNumberOfCopiesForSelectedRowForPriceTable,
};


export default connect(mapStateToProps, mapDispatchToProps)(TableContentRow);